import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DataProvider } from './context/DataContext';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import MRVFlows from './components/MRVFlows';
import ClimateMetrics from './components/ClimateMetrics';
import CircularWaste from './components/CircularWaste';
import BiogasIntegration from './components/BiogasIntegration';
import ScenarioModeling from './components/ScenarioModeling';
import AIAssistant from './components/AIAssistant';
import SmartAlerts from './components/SmartAlerts';
import MRVReportGenerator from './components/MRVReportGenerator';
import DigitalTwin from './components/DigitalTwin';
import DataUpload from './components/DataUpload';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <DataProvider>
      <Router>
        <div className="App">
          <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route 
            path="/login" 
            element={
              isAuthenticated ? 
              <Navigate to="/dashboard" /> : 
              <Login onLogin={() => setIsAuthenticated(true)} />
            } 
          />
          <Route 
            path="/dashboard" 
            element={
              isAuthenticated ? 
              <Dashboard /> : 
              <Navigate to="/login" />
            } 
          />
          <Route 
            path="/mrv" 
            element={
              isAuthenticated ? 
              <MRVFlows /> : 
              <Navigate to="/login" />
            } 
          />
          <Route 
            path="/climate-metrics" 
            element={
              isAuthenticated ? 
              <ClimateMetrics /> : 
              <Navigate to="/login" />
            } 
          />
          <Route 
            path="/circular-waste" 
            element={
              isAuthenticated ? 
              <CircularWaste /> : 
              <Navigate to="/login" />
            } 
          />
          <Route 
            path="/biogas" 
            element={
              isAuthenticated ? 
              <BiogasIntegration /> : 
              <Navigate to="/login" />
            } 
          />
          <Route 
            path="/scenarios" 
            element={
              isAuthenticated ? 
              <ScenarioModeling /> : 
              <Navigate to="/login" />
            } 
          />
          <Route 
            path="/ai-assistant" 
            element={
              isAuthenticated ? 
              <AIAssistant /> : 
              <Navigate to="/login" />
            } 
          />
          <Route 
            path="/smart-alerts" 
            element={
              isAuthenticated ? 
              <SmartAlerts /> : 
              <Navigate to="/login" />
            } 
          />
          <Route 
            path="/mrv-generator" 
            element={
              isAuthenticated ? 
              <MRVReportGenerator /> : 
              <Navigate to="/login" />
            } 
          />
          <Route 
            path="/digital-twin" 
            element={
              isAuthenticated ? 
              <DigitalTwin /> : 
              <Navigate to="/login" />
            } 
          />
          <Route 
            path="/data-upload" 
            element={
              isAuthenticated ? 
              <DataUpload /> : 
              <Navigate to="/login" />
            } 
          />
          </Routes>
        </div>
      </Router>
    </DataProvider>
  );
}

export default App;
